import { z } from 'zod'

/**
 * 拡散用SNS（Share SNS）ドメインのスキーマ。
 * バックエンド #3285（`SpotController` の share-sns 系）の API 契約に対応する。
 */

export const ShareSnsTypeEnum = z.enum(['facebook', 'x', 'instagram', 'tiktok'])
export type ShareSnsType = z.infer<typeof ShareSnsTypeEnum>

/** 拡散の発火点 */
export const ShareSnsContextEnum = z.enum(['stamp', 'ar_photo'])
export type ShareSnsContext = z.infer<typeof ShareSnsContextEnum>

// ─────────────────────────────────────────────
// GET /api/v2/spots/{id}/share-sns
// ─────────────────────────────────────────────
export const ShareSnsItemDataSchema = z.object({
  type: ShareSnsTypeEnum,
  /** 拡散先を開くURL。Instagram / TikTok はアプリのトップURL */
  shareUrl: z.string(),
  /** クリップボードにコピーする文言。X は shareUrl に全て含まれるため null */
  copyText: z.string().nullable(),
})
export type ShareSnsItemData = z.infer<typeof ShareSnsItemDataSchema>

export const ShareSnsDataSchema = z.object({
  /** このコンテキストで SNS 拡散を表示してよいか。false のとき items は空 */
  enabled: z.boolean(),
  /** OGP が設定されたスポットのURL。enabled=false のとき null */
  ogpUrl: z.string().nullable(),
  items: z.array(ShareSnsItemDataSchema),
})
export type ShareSnsData = z.infer<typeof ShareSnsDataSchema>

/**
 * GET /api/v2/spots/{id}/share-sns クエリパラメータ。
 * context による discriminated union で「context=stamp のとき stampId 必須」を型で担保する。
 */
export type GetShareSnsParams =
  | { context: 'stamp'; stampId: number }
  | { context: 'ar_photo'; stampId?: undefined }

// ─────────────────────────────────────────────
// POST /api/v2/spots/{id}/share-sns/taps
// ─────────────────────────────────────────────
export const ShareSnsTapResponseSchema = z.object({
  /** 記録した拡散タップ履歴のID */
  id: z.number(),
})
export type ShareSnsTapResponse = z.infer<typeof ShareSnsTapResponseSchema>

/**
 * POST /api/v2/spots/{id}/share-sns/taps リクエストボディ。
 * context による discriminated union で「context=stamp のとき stampId 必須」を型で担保する。
 */
export type RecordShareSnsTapRequest =
  | { snsType: ShareSnsType; context: 'stamp'; stampId: number }
  | { snsType: ShareSnsType; context: 'ar_photo'; stampId?: undefined }
